import { render } from "./BasicInput.vue?vue&type=template&id=54be1abe&scoped=true"
import script from "./BasicInput.vue?vue&type=script&lang=js"
export * from "./BasicInput.vue?vue&type=script&lang=js"

import "./BasicInput.vue?vue&type=style&index=0&id=54be1abe&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src17432379/src/orprio-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54be1abe"]])

export default __exports__